<script>
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import AnimatedImage from '../components/AnimatedImage.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
</script>

<section class="part6 super-wide">
  <AnimatedImage
    superWide={true}
    desktop="https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615951961/VerizonMediaATV/linear-img1-desktop_bg4tjm.jpg"
    mobile="https://res.cloudinary.com/tanka-design/image/upload/q_auto,c_scale,w_768/v1615951961/VerizonMediaATV/linear-img1-desktop_bg4tjm.jpg"
    alt="3 friends sitting in a living room talking"
    title="Hold your Upfronts accountable with rich insights." />
  <div class="content">
    <div class="rgrid-md-1-2">
      <div class="col"></div>
      <div class="col">
        <AnimatedLine size={5} color="white" />
        <AnimatedBlock>
          <p class="point1"><strong class="accent">Enjoy greater control</strong>, flexibility and transparency into your media’s performance.</p>
        </AnimatedBlock>
        <AnimatedBlock>
          <p class="point2"><strong class="accent">Access key audience insights,</strong> zoom into publisher performance and clearly see the impact of your upfront campaigns on business outcomes.</p>
        </AnimatedBlock>
      </div>
    </div>
  </div>
</section>

<style>
  .part6 :global(.animated-image) {
    margin-bottom: 45px;
  }
  .part6 :global(.hline) {
    margin-bottom: 0.5rem;
  }
  .part6 :global(.point2) {
    margin-top: 1.5rem;
    margin-bottom: 0;
  }
  @media(min-width: 768px) {
    .part6 :global(.animated-image) {
      margin-bottom: 72px;
    }
  }
</style>